import { ServiceCard } from '@aibees/elephant/components';
import { CrawlRequestErrorProvider } from '@aibees/elephant/feature/suggestion-search-bar/components/crawl-request/crawl-request-error-context';
import { Grid2, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button } from '@mui/material';
import { memo, useState } from 'react';
import { serviceCards } from './config';
import { useGetCardsPerRow } from './hooks/use-get-cards-per-row';
import * as Styled from './styles';
import * as SX from './sx';
import type { ServiceCardWrapperProps as Props } from './types';

export const ServiceCardWrapper = memo(({ className }: Props) => {
  const [showMore, setShowMore] = useState<boolean>(false);

  const cardsPerRow = useGetCardsPerRow();

  const initialVisibleCards = cardsPerRow * 2;

  const displayedCards = showMore
    ? serviceCards
    : serviceCards.slice(0, initialVisibleCards);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  return (
    <Styled.Wrapper
      className={classnames('ServiceCardWrapper', className)}
      sx={SX.root}
      gap={4.5}
    >
      <Grid2 container columns={cardsPerRow} spacing={1}>
        {displayedCards.map((service, index) => (
          <Grid2 xs={1} key={service.title}>
            <CrawlRequestErrorProvider>
              <ServiceCard service={service} />
            </CrawlRequestErrorProvider>
          </Grid2>
        ))}
      </Grid2>
      {serviceCards.length > initialVisibleCards && (
        <Box display="flex" justifyContent="center">
          <Button
            variant="outlined"
            size="small"
            color="primary"
            startIcon={<Icon name="more-grid" size={16} />}
            onClick={handleToggle}
          >
            {showMore ? 'Show Less' : 'Show More'}
          </Button>
        </Box>
      )}
    </Styled.Wrapper>
  );
});

ServiceCardWrapper.displayName = 'ServiceCardWrapper';
